// @flow
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classnames from 'classnames';
import { pad } from '../../../utils';
import { toDurationObject } from '../../../utils/zoneUtils';

const getValue = (type, durationObject) => ( durationObject ? pad(durationObject[type]) : '--' );

const useStyles = makeStyles({
    root: {
        whiteSpace: 'nowrap',
        fontFamily: '"Roboto Mono", monospace',
        letterSpacing: '-0.5px'
    },
});

type Props = $ReadOnly<{
    duration: ?number,
    className?: string
}>;

function Duration({ duration, className }: Props) {
    const classes = useStyles();
    const durationObject = duration && toDurationObject(duration);

    return (
        <span className={classnames(classes.root, className)}>
            {getValue('hours', durationObject)}:{getValue('minutes', durationObject)}:{getValue('seconds', durationObject)}
        </span>
    );
}

export default Duration;